import { Box, Typography, useTheme } from '@mui/material';
import { alpha } from '@mui/material/styles';

const PageHeader = ({ 
  title, 
  subtitle, 
  variant = 'h4',
  showGradient = true,
  sx = {},
  ...props 
}) => {
  const theme = useTheme();

  return (
    <Box 
      sx={{ 
        mb: 2.5, 
        position: 'relative',
        '&:before': {
          content: '""',
          position: 'absolute',
          bottom: -6,
          left: 0,
          width: '50px',
          height: '3px',
          background: showGradient 
            ? `linear-gradient(90deg, ${theme.palette.primary.main} 0%, ${theme.palette.secondary.main} 100%)`
            : theme.palette.primary.main,
          borderRadius: '2px',
        },
        ...sx 
      }} 
      {...props}
    >
      <Typography 
        variant={variant}
        sx={{ 
          fontWeight: 700,
          fontSize: { xs: '1.25rem', sm: '1.4rem', md: '1.5rem' },
          color: showGradient ? 'transparent' : 'text.primary',
          background: showGradient 
            ? `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.secondary.main} 50%, ${theme.palette.primary.dark} 100%)`
            : 'none',
          backgroundClip: showGradient ? 'text' : 'initial',
          WebkitBackgroundClip: showGradient ? 'text' : 'initial',
          WebkitTextFillColor: showGradient ? 'transparent' : 'initial',
          mb: subtitle ? 1 : 0,
          letterSpacing: '-0.25px',
          textShadow: showGradient ? '0 1px 2px rgba(0,0,0,0.1)' : 'none',
          ...sx
        }}
      >
        {title}
      </Typography>
      {subtitle && (
        <Typography 
          variant="body2" 
          sx={{ 
            color: 'text.secondary',
            fontWeight: 400,
            fontSize: { xs: '0.8rem', sm: '0.85rem', md: '0.9rem' },
            opacity: 0.8,
            letterSpacing: '0.1px',
            lineHeight: 1.4,
          }}
        >
          {subtitle}
        </Typography>
      )}
    </Box>
  );
};

export default PageHeader;
